<template>
  <div>
    <Breadcrumbs main="Beacon" title="Case Management" />

    <div class="container-fluid">
      <div class="d-flex justify-content-end m-3">
        <b-button
          variant="primary"
          class="btn-pill"
          @click="$router.push('/beacon/new')"
        >
          <i class="icofont icofont-plus-circle"></i> Add New</b-button
        >
      </div>
      <b-modal v-if="view" v-model="modalShow" size="lg" hide-footer centered>
        <div class="ribbon-wrapper card m-0" v-if="view.send_email">
          <div class="card-body p-3">
            <div class="ribbon ribbon-primary">Email</div>
            <h4 class="mb-3">{{ view.subject_email }}</h4>
            <p
              class="border rounded p-3"
              style="height: 100%"
              v-html="view.message_email"
            ></p>
          </div>
        </div>

        <div class="ribbon-wrapper card m-0" v-if="view.send_sms">
          <div class="card-body p-3">
            <div class="ribbon ribbon-primary">SMS</div>
            <p class="border rounded p-3" style="height: 100%">
              {{ view.message_sms }}
            </p>
          </div>
        </div>

        <template #modal-footer>
          <button
            @click="modalShow = !modalShow"
            class="btn btn-danger btn-pill btn-sm m-1 d-flex align-item-center"
          >
            <i class="icofont icofont-close mr-1" style="font-size: 1rem"></i>
            Cancel
          </button>
          <button
            @click="sendEmail"
            class="btn btn-success btn-pill btn-sm m-1 d-flex align-item-center"
          >
            <i
              class="icofont icofont-send-mail mr-1"
              style="font-size: 1.2rem"
            ></i>
            Send
          </button>
        </template>
      </b-modal>
      <div class="card p-4">
        <dataTableVue
          ref="refDataTable"
          :isSearch="false"
          :isSetting="false"
          :isExport="false"
          :isFilter="true"
          v-bind:data="{
            module: 'beacon',
            columns: columns,
            rows: rows,
            filter_col: [0, 3],
            filter_custom: 'dynamicFilterVue',
            headTopic: headTopic,
          }"
          @load="loadItems"
          @openModal="openModal"
          @resend="resend"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../../router';
  import { requestService } from './../../_services';

  export default {
    data() {
      return {
        modalShow: false,
        headTopic: ['Case'],
        columns: [
          {
            topic: 'Case',
            label: 'Incident ID',
            field: 'incident',
            hidden: false,
            visible: true,
          },
          {
            topic: 'Case',
            label: 'Description',
            field: 'description',
            hidden: false,
            visible: true,
          },
          {
            topic: 'Case',
            label: 'Type',
            field: 'announcement_type',
            hidden: false,
            visible: true,
          },
          {
            topic: 'Case',
            label: 'Create Date',
            field: 'created_at',
            hidden: false,
            visible: true,
          },
          // {
          //   topic: 'Case',
          //   label: 'Update date',
          //   field: 'updated_at',
          //   hidden: false,
          //   visible: true,
          // },
          {
            topic: 'Case',
            label: 'Action',
            field: 'action',
            thClass: 'custom-th-class',
            hidden: false,
            visible: true,
          },
        ],
        rows: [],
        view: null,
      };
    },
    mounted() {
      // this.loadColumn();
      setTimeout(() => this.loadItems(), 1000);
    },
    methods: {
      resend(v) {
        router.push({ path: '/beacon/new', query: { id: v.row._id } });
      },
      openModal(value, id) {
        let url = `/api/casemanagement/show/${id.row._id}`;
        requestService
          .GetFetch('beacon', url)
          .then((response) => {
            if (response.status == 200) {
              response.text().then((text) => {
                const data = text && JSON.parse(text);
                this.view = data.data[0];
                this.modalShow = true;
              });
            }
          })
          .catch((error) => {
            this.$notify({ text: error, type: 'danger' });
          });
      },
      async loadItems(event) {
        var str = '';
        if (event != undefined) {
          for (var key in event.params) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.params[key]);
          }
          this.columns.forEach((element) => {
            if (event.sortField == element.field) {
              if (
                event.sortField == 'created_at' ||
                event.sortField == 'updated_at'
              ) {
                str += '&' + 'sortField=' + event.sortField;
              } else {
                str += '&' + 'sortField=' + element.field;
              }
            }
          });
          if (event.filter != undefined) {
            for (var key in event.filter) {
              if (str != '') {
                str += '&';
              }
              str += key + '=' + encodeURIComponent(event.filter[key]);
            }
          }
        }
        if (str == '') {
          str = 'sortType=desc&sortField=created_at';
        }
        const url = '/api/casemanagement/filter?' + str;

        return requestService
          .GetFetch('beacon', url)
          .then((response) => {
            if (response.status == 200) {
              response.text().then((text) => {
                let self = this;
                self.rows = [];
                const data = text && JSON.parse(text);

                if (data.data.data != null) {
                  self.json_data = data.data.data;
                  self.rows = data.data.data;
                  self.$refs.refDataTable.setTotalRecords(data.data.total);
                  self.$refs.refDataTable.setPages(data.data.current_page);
                } else {
                  self.$refs.refDataTable.setTotalRecords(0);
                  self.$refs.refDataTable.setPages(1);
                }
              });
            }
          })
          .catch((error) => {
            this.$notify({ text: error, type: 'danger' });
          });
      },
    },
  };
</script>

<style></style>
